module.exports = __webpack_public_path__ + "static/media/women-will.fa0f2f9f.png";